module.exports = __webpack_public_path__ + "img/rewind-right.f01193d3.svg";